











































































































































import Vue from 'vue'
import Person from '@/assets/svgs/person.svg?inline'
import { FETCH_PERSONAL_INFO, UPDATE_PERSONAL_INFO, GET_SIGNED_URL_PROFILE_PHOTO_JPG, GET_SIGNED_URL_PROFILE_PHOTO_PNG, REMOVE_PROFILE_PHOTO } from '@/graphql.js'
import Upload from '@/assets/svgs/upload.svg?inline'
import TrashIcon from '@/assets/svgs/trash_icon.svg?inline'
import Input from '@/components/atoms/Input.vue'
import FormButtons from '@/components/userProfile/FormButtons.vue'
import ActionToast from '@/components/atoms/ActionToast.vue'
import { UserProfile } from 'vue/types/vue'

const twoMegabytes = 2097152
const allowedFileTypes = ['image/jpg', 'image/jpeg', 'image/png']

export default Vue.extend({
  name: 'PersonalInfo',
  components: {
    Person,
    Upload,
    TrashIcon,
    FormButtons,
    ActionToast,
    'car-input': Input
  },
  data: () => ({
    userProfile: {} as UserProfile,
    form: {
      firstName: '',
      middleName: '',
      lastName: '',
      avatar: '',
      email: '',
      phoneNumber: '',
    },
    error: '' as string,
    showRequiredFieldsDialog: false,
    showNavigationWarning: false,
    savedSuccessfully: false,
    saveError: false,
    showDiscardDialog: false,
    showRemovePhotoWarning: false,
    showFileSizeWarning: false,
    showFileTypeWarning: false,
    selectedFile: {} as File,
    supportUrl: process.env.VUE_APP_LEARNER_SUPPORT_URL!,
  }),
  computed: {
    hasEdits (): boolean {
      return (this.form.avatar !== (this.userProfile.avatarUrl ? this.userProfile.avatarUrl : ''))
    },
    showError (): boolean {
      return !!this.error && this.error !== ''
    },
    profileImageUrl (): string {
      if (this.selectedFile.size) {
        // Display image preview
        return this.form.avatar
      } else {
        // Display image saved in s3 bucket
        return `${process.env.VUE_APP_FILE_STORAGE_PATH}/${this.form.avatar}`
      }
    },
  },
  methods: {
    uploadPhoto (event) {
      const file = event.target.files[0]
      if (file.size > twoMegabytes || !allowedFileTypes.includes(file.type)) {
        let changePhotoInput = this.$refs.changePhotoInput as HTMLInputElement
        changePhotoInput.value = ''
        if (file.size > twoMegabytes) {
          this.showFileSizeWarning = true
        } else {
          this.showFileTypeWarning = true
        }
      } else {
        this.selectedFile = file
        // Temporarily assign the avatar so that the selected image will display
        this.form.avatar = URL.createObjectURL(this.selectedFile)
        // Reset the value of the input so the change event will fire if the image is changed back to the original
        event.target.value = ''
      }
    },
    removePhoto (): void {
      this.form.avatar = ''
      this.selectedFile = {} as File
      this.showRemovePhotoWarning = false
    },
    setDataFromProfile (profile: UserProfile): void {
      const { firstName, middleName, lastName, email, phoneNumber, avatarUrl } = profile

      this.form.firstName = firstName
      this.form.lastName = lastName
      this.form.middleName = middleName || ''

      this.form.avatar = avatarUrl || ''
      this.form.email = email
      this.form.phoneNumber = phoneNumber ?? ''

      this.selectedFile = {} as File
    },
    cancel (): void {
      // Revert fields by setting values from this.userProfile
      this.showDiscardDialog = false
      this.setDataFromProfile(this.userProfile)
    },
    save: async function () {
      if (this.hasEdits) {
        this.saveError = false
        try {
          // Create variable to store the new profile image URL if photo was changed
          let newProfileImageUrl = this.form.avatar
          if (this.selectedFile.size) {
            // Get signed URL
            let signedUrlResponse = await this.$apollo.mutate({
              mutation: this.selectedFile.type === 'image/png' ? GET_SIGNED_URL_PROFILE_PHOTO_PNG : GET_SIGNED_URL_PROFILE_PHOTO_JPG
            })
            await fetch(signedUrlResponse.data.requestSignedS3Url.url, {
              method: 'PUT',
              headers: {
                'Content-Type': this.selectedFile.type,
              },
              body: this.selectedFile
            })
            newProfileImageUrl = signedUrlResponse.data.requestSignedS3Url.fileKey
          }
          if (this.form.avatar === '' && this.userProfile.avatarUrl !== '') {
            await this.$apollo.mutate({
              mutation: REMOVE_PROFILE_PHOTO,
            })
          }
          const updates = {
            avatarUrl: `${newProfileImageUrl}`,
          }
          await this.$apollo.mutate({
            mutation: UPDATE_PERSONAL_INFO,
            variables: { uuid: this.userProfile.uuid, updates: updates }
          })
          this.$apollo.queries.userProfile.refresh()
          this.savedSuccessfully = true
        } catch (e) {
          this.error = (e as Error).message
          this.saveError = true
        }
      }
    }
  },
  beforeRouteLeave: function (to, from, next) {
    if (this.$route.params?.masqueradeUser) {
      next()
    }
    if (this.hasEdits) {
      this.$emit('hideNavMenu')
      this.showNavigationWarning = true
    } else {
      next()
    }
  },
  watch: {
    userProfile: function (value) {
      this.setDataFromProfile(value)
    }
  },
  apollo: {
    userProfile: {
      query: FETCH_PERSONAL_INFO,
      variables: function () {
        if (this.$route.params?.masqueradeUser) {
          return { input: this.$route.params?.masqueradeUser }
        }
      },
      update: data => data.user as UserProfile
    }
  },
})
